import theme from '@/style';
import React, {FC, useEffect, useState} from 'react';
import {View} from 'react-native';
import {BasicObject, NavigatorScreenProps} from '@/types';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import {
  BottomTabNavigationOptions,
  createBottomTabNavigator,
} from '@react-navigation/bottom-tabs';
import Home from './pages/home';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {Shadow} from 'react-native-shadow-2';
import Me from './pages/me';
// import Promotion from '@/common-pages/promotion';
import Casino from './pages/casino';
import LiveCasino from './pages/live-casino';
import {goCS, toAgentApply, toSports} from './utils';
import {Image} from 'antd-mobile';
// import IMWebView from './common-pages/im/im-webview';
// import {toAgentApply} from '@/utils';
// import {toChat} from '@/common-pages/game-navigate';

const Tab = createBottomTabNavigator();

const homeIcon = require('@assets/icons/main-tab/home-new-2.webp');
const homeActiveIcon = require('@assets/icons/main-tab/home-active-new.webp');
const sportIcon = require('@assets/icons/main-tab/sport-new.webp');
const sportActiveIcon = require('@assets/icons/main-tab/sport-active.webp');
const liveIcon = require('@assets/icons/main-tab/live.webp');
const liveActiveIcon = require('@assets/icons/main-tab/live-active.webp');
const casinoIcon = require('@assets/icons/main-tab/casino-new.webp');
const casinoActiveIcon = require('@assets/icons/main-tab/casino-active.webp');
const meIcon = require('@assets/icons/main-tab/me-new.webp');
const meActiveIcon = require('@assets/icons/main-tab/me-active.webp');
const chatIcon = require('@assets/icons/main-tab/chat-new.webp');
const chatActiveIcon = require('@assets/icons/main-tab/chat-active.webp');
import {goTo} from './utils';
import {homePage, useGR8Sports} from './config';
import Sports from './common-pages/sports';
import {getGameURL} from './pages/home/home.service';
import {useScreenSize} from './common-pages/hooks/size.hooks';
import SportsContainer from './common-pages/sports/container';
// import SportsContainer from './common-pages/sports/container';

const shadow = {
  startColor: '#0004',
  distance: 1,
  offset: [0, 0],
  style: [
    theme.flex.row,
    theme.flex.around,
    theme.background.white,
    theme.fill.fillW,
    // {
    //   height: 50,
    // },
  ] as BasicObject[],
} as BasicObject;

if (globalStore.isWeb) {
  shadow.distance = 0;
  delete shadow.offset;
  shadow.style.push({
    boxShadow: '0 0 1px 0px #0004',
  });
}

export const mainPageList: {
  name: string;
  link: string;
  component: (props: NavigatorScreenProps) => React.JSX.Element;
  img?: string;
  activeImg?: string;
  unmountOnBlur?: boolean;
  lazy?: boolean;
  params?: BasicObject;
  svgIcon?: ({active}: {active: boolean}) => React.ReactNode;
}[] = [
  {
    name: 'Home',
    link: 'index/home',
    component: Home,
    img: homeIcon,
    activeImg: homeActiveIcon,
  },
  // {
  //   name: 'Promotions',
  //   link: 'index/promotion',
  //   component: Promotion,
  //   img: promotionsIcon,
  //   activeImg: promotionsActiveIcon,
  // },
  useGR8Sports
    ? {
        name: 'Sports',
        link: 'index/sports',
        component: SportsContainer,
        img: sportIcon,
        activeImg: sportActiveIcon,
        lazy: false,
      }
    : {
        name: 'Sports',
        link: 'index/sports',
        component: Sports,
        img: sportIcon,
        activeImg: sportActiveIcon,
      },

  {
    name: 'Live',
    link: 'index/live',
    component: LiveCasino,
    img: liveIcon,
    activeImg: liveActiveIcon,
  },
  {
    name: 'Casino',
    link: 'index/casino',
    component: Casino,
    img: casinoIcon,
    activeImg: casinoActiveIcon,
  },
  {
    name: 'Chat',
    link: 'index/chat',
    component: () => <View />,
    img: chatIcon,
    activeImg: chatActiveIcon,
    // lazy: false,
  },

  // {
  //   name: 'ProxyHome',
  //   link: 'index/proxy-home',
  //   component: ProxyHome,
  //   svgIcon: AgentIcon,
  //   params: {
  //     hideBack: true,
  //   },
  // },
  {
    name: 'Me',
    link: 'index/me',
    component: Me,
    img: meIcon,
    activeImg: meActiveIcon,
  },
];

const CusDefautTab = ({
  index,
  label,
  isFocused,
  options,
  onPress,
  count,
}: {
  index: number;
  label: string;
  isFocused: boolean;
  options: BottomTabNavigationOptions;
  onPress: (isFocused: boolean) => void;
  count?: number;
}) => {
  const {calcActualSize} = useScreenSize();
  return (
    <NativeTouchableOpacity
      activeOpacity={0.8}
      accessibilityRole="button"
      accessibilityState={isFocused ? {selected: true} : {}}
      accessibilityLabel={options?.tabBarAccessibilityLabel}
      testID={options?.tabBarTestID}
      onPress={() => onPress(isFocused)}
      style={[
        theme.flex.centerByCol,
        theme.flex.flex1,
        theme.position.rel,
        theme.overflow.visible,
        {gap: calcActualSize(4), paddingVertical: calcActualSize(8)},
      ]}>
      <View style={[theme.position.rel]}>
        {
          <>
            <div
              className={` ${
                isFocused ? 'visible size-6' : 'invisible size-0'
              }`}>
              <Image
                className="size-full"
                src={mainPageList[index].activeImg!}
              />
            </div>
            <div
              className={` ${
                isFocused ? 'invisible size-0' : 'visible size-6'
              }`}>
              <Image className="size-full" src={mainPageList[index].img!} />
            </div>
          </>
        }
        {!!count && count > 0 && (
          <View
            style={[
              theme.flex.center,
              theme.position.abs,
              {
                paddingHorizontal: 5,
                paddingVertical: 2,
                borderWidth: 1,
                borderColor: '#FFF',
                borderRadius: 9999,
                backgroundColor: '#DC083B',
                left: 15,
                top: -8,
              },
            ]}>
            <span className="font-din text-white font-bold text-[0.625rem]">
              {count > 99 ? '99+' : count}
            </span>
          </View>
        )}
      </View>

      <span
        className={`text-[0.625rem] leading-none ${
          isFocused ? 'font-bold' : ''
        }`}>
        {label}
      </span>
    </NativeTouchableOpacity>
  );
};

interface TabBarListItem {
  name: string;
  options?: BottomTabNavigationOptions;
}
interface TabBarListProps {
  list: TabBarListItem[];
  activeIndex: number;
}

export const TabBarList: FC<TabBarListProps> = ({list, activeIndex}) => {
  const [imCount, setImCount] = React.useState<number>(0);
  const {t} = useTranslation();
  const [token, setToken] = useState('');
  useEffect(() => {
    const countStr = localStorage.getItem('imCount') || '0';
    setImCount(Number(countStr));
    const sub = globalStore.chatNumSubject.subscribe(count => {
      setImCount(count);
    });
    const tokenSub = globalStore.tokenSubject.subscribe(_token => {
      setToken(_token || '');
    });
    return () => {
      sub.unsubscribe();
      tokenSub.unsubscribe();
    };
  }, []);
  return (
    <Shadow containerViewProps={{id: 'tabbar-container'}} {...shadow}>
      {list.map((item, index) => {
        const onPress = (isFocused: boolean) => {
          if (isFocused) {
            return;
          }
          if (item.name === 'ProxyHome') {
            if (globalStore.userInfo?.isAgent !== 1) {
              return toAgentApply();
            }
          }
          // if (item.name === 'Chat' && !token) {
          //   goTo('Login', {
          //     backPage: homePage,
          //     sucessPage: homePage,
          //     sucessPageParams: {
          //       screen: 'Chat',
          //     },
          //   });
          //   return;
          // }
          if (item.name === 'Sports' && !useGR8Sports) {
            // globalStore.openSports.next(undefined);
            if (!token) {
              goTo('Login');
              return;
            }
            getGameURL('saba_sport').then(url => {
              toSports('SABA Sports', url);
            });
            return;
          }
          if (item.name === 'Sports' && useGR8Sports) {
            globalStore.openSports.next(undefined);
            return;
          }
          if (item.name === 'Chat') {
            goCS();
            return;
          }
          goTo(homePage, {
            screen: item.name,
          });
        };
        return (
          <CusDefautTab
            key={item.name}
            index={index}
            label={t(`home.tab.${item.name.toLocaleLowerCase()}`)}
            isFocused={activeIndex === index}
            options={item.options || {}}
            onPress={onPress}
            count={item.name === 'Chat' ? imCount : 0}
          />
        );
      })}
    </Shadow>
  );
};

const MainNav = () => {
  const {i18n} = useTranslation();

  return (
    <Tab.Navigator
      // eslint-disable-next-line react/no-unstable-nested-components
      tabBar={props => {
        return (
          <TabBarList
            list={props.state.routes.map(route => {
              const {options} = props.descriptors[route.key];
              return {
                name: route.name,
                options: options,
              };
            })}
            activeIndex={props.state.index}
          />
        );
      }}
      backBehavior="none"
      screenOptions={{
        headerShown: false,
      }}>
      {mainPageList.map(v => (
        <Tab.Screen
          key={v.name}
          name={v.name}
          component={v.component}
          options={{
            title: i18n.t(`home.tab.${v.name.toLocaleLowerCase()}`),
            unmountOnBlur: v.unmountOnBlur,
            lazy: v.lazy,
          }}
          initialParams={v.params}
        />
      ))}
    </Tab.Navigator>
  );
};

export default MainNav;
